import React from 'react'
import { Button } from './ui/Button'
import { LogOut } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface ConfirmationModalProps {
  show: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
  onConfirm: () => void
}

const ConfirmationModal = (props: ConfirmationModalProps) => {
  const [show, setShow] = props.show
  const onConfirm = props.onConfirm
  const { t } = useTranslation()

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50'>
      <div className='flex flex-col items-center bg-white rounded-lg p-4 gap-4'>
        <div className='bg-gray-100 border rounded-full p-4'>
          <LogOut className='w-10 h-10' />
        </div>
        <h1 className='text-2xl font-bold text-center'>{t('components.confirmationModal.logout')}</h1>
        {/* starts:: main actions */}
        <div className='flex flex-col items-center justify-center gap-6'>
          <h1 className='text-center'>{t('components.confirmationModal.logoutConfirmation')}</h1>
          <div className='w-full grid grid-cols-2 gap-4'>
            <Button
              variant='outline'
              className='w-full col-span-1'
              onClick={onConfirm}
            >
              {t('components.confirmationModal.confirm')}
            </Button>
            <Button
              className='w-full col-span-1 bg-black text-white hover:bg-gray-800'
              // bg-yellow-50 outline-yellow-500 text-yellow-500
              onClick={() => setShow(false)}
            >
              {t('components.confirmationModal.cancel')}
            </Button>
          </div>
        </div>
        {/* ends:: main actions */}
      </div>
    </div>
  )
}

export default ConfirmationModal
